import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { MarkupUploadingAttachmentItem } from "@pages/project-details/project-markups/sidepanel/attachment/markup-uploading-attachment-item";
import { useAppSelector } from "@store/store-helper";
import { incompleteMarkupAttachmentUploadTasksSelector } from "@store/upload-tasks/upload-tasks-selector";
import { memo } from "react";
/**
 * Renders markup attachment upload tasks.
 */
function MarkupUploadingAttachmentComponent(t0) {
  const $ = _c(9);
  const {
    markupId
  } = t0;
  let t1;
  if ($[0] !== markupId) {
    t1 = incompleteMarkupAttachmentUploadTasksSelector(markupId);
    $[0] = markupId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tasks = useAppSelector(t1);
  if (!tasks.length) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      borderBottom: 1,
      borderColor: "divider",
      mt: "5px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== tasks) {
    let t4;
    if ($[5] !== tasks.length) {
      t4 = (task, i) => <MarkupUploadingAttachmentItem task={task} key={i} isLastElement={i === tasks.length - 1} />;
      $[5] = tasks.length;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = tasks.map(t4);
    $[3] = tasks;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Box sx={t2}>{t3}</Box>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export const MarkupUploadingAttachment = memo(MarkupUploadingAttachmentComponent);